module.exports = __webpack_public_path__ + "media/country_flags/pw-23946c5e.png";